import React from 'react'
import MaterialTable from "material-table";
import tableIcons from "../../resources/tableIcons";
import { trash } from "ionicons/icons";
import { IonIcon } from "@ionic/react";


const PurchaseTable = ({ data, removeBill }) => {
    const columns = [
        {
            title: 'Bill No.',
            field: 'billNo'
        },
        {
            title: 'Bill Date',
            field: 'billDate',
            type: 'date'
        },
        {
            title: 'Party',
            field: 'partyName',
        },
        {
            title: 'No. of Products',
            field: 'products.length'
        },
        {
            title: 'Taxable Amount',
            field: 'subtotalAmt',
            type: 'currency', currencySetting: { currencyCode: 'INR' },
        },
        {
            title: 'Total Amount',
            field: 'totalAmt',
            type: 'currency', currencySetting: { currencyCode: 'INR' },
        }
    ];



    return (
        <MaterialTable columns={columns} icons={tableIcons}
            options={{
                headerStyle: {
                    backgroundColor: '#989aa2',
                    color: '#FFF'
                },
                actionsColumnIndex: -1,
                pageSize: 10,
                pageSizeOptions: [10, 20, 50, 100],
                columnsButton: true,
                exportButton: true,
                exportFileName: 'Purchase List',

            }}
            data={data}
            actions={[
                {
                    icon: () => <IonIcon icon={trash}></IonIcon>,
                    tooltip: 'Delete Bill',
                    onClick: (event, rowData) => {
                        removeBill(rowData.id)
                    },
                },

            ]}
            onRowClick={(event, rowData, togglePanel) => {
                togglePanel();
            }}
            detailPanel={rowData => {
                return (
                    <MaterialTable columns={[
                        {
                            title: 'Product Name',
                            field: 'name'
                        },
                        {
                            title: 'Quantity',
                            field: 'quantity',
                        },
                        {
                            title: 'Rate',
                            field: 'rate',
                            type: 'currency', currencySetting: { currencyCode: 'INR' },
                        },
                        {
                            title: 'Amount',
                            field: 'amount',
                            type: 'currency', currencySetting: { currencyCode: 'INR' },
                            
                        }
                    ]}
                        options={{
                            headerStyle: {
                                backgroundColor: '#eeeeee',
                                color: '#000' 
                            },
                            toolbar: false,
                            paging: false,
                            padding: 'dense',
                        }}
                    

                        data={rowData.products} icons={tableIcons} />
                )
            }}      
            title="Purchase List" />
    )
}


export default PurchaseTable
